module.exports = __webpack_public_path__ + "img/9788989456292.e7501227.jpg";